let selectedInput = null;
let currentCallback = null;

export const setSelectedInput = (callback) => {
    selectedInput = document.activeElement;
    currentCallback = callback;
}

export const getSelectedInput = ()=>{
    return selectedInput;
}

export const getCurrentCallback = ()=>{
    return currentCallback;
}

export default (setSelectedInput, getSelectedInput)
